const DocumentTemplate = {
    title: "Form Admin",
};
export default DocumentTemplate;
